import { getAppointmentDisplayMeta } from '../../utils/appointmentWorkflow';

/** Maps raw status strings to pill CSS modifiers used across overview cards. */
export function getAppointmentStatusPillClass(status) {
  const normalized = String(status || 'confirmed').trim().toLowerCase();

  if (normalized === 'no show' || normalized === 'no-show' || normalized === 'no_show') {
    return 'no-show';
  }
  if (normalized === 'cancelled' || normalized === 'canceled') {
    return 'cancelled';
  }
  if (normalized === 'pending_payment' || normalized === 'processing') {
    return 'pending-payment';
  }
  if (normalized === 'awaiting confirmation' || normalized === 'awaiting-confirmation') {
    return 'awaiting-confirmation';
  }
  if (normalized === 'checked_in' || normalized === 'checked-in') {
    return 'checked-in';
  }

  return normalized.replace(/[_\s]+/g, '-') || 'confirmed';
}

/** Capitalize the first letter of each word for pill display. */
export function formatStatusPillLabel(label) {
  if (!label) return '';

  return String(label)
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export function getAppointmentStatusPillLabel(status) {
  const normalized = String(status || 'confirmed').trim().toLowerCase();

  if (normalized === 'no show' || normalized === 'no-show' || normalized === 'no_show') {
    return 'no show';
  }
  if (normalized === 'cancelled' || normalized === 'canceled') {
    return 'cancelled';
  }
  if (normalized === 'pending') {
    return 'pending';
  }

  return 'confirmed';
}

export function getAppointmentStatusPillMeta(appointment, rescheduleStatus) {
  if (!appointment) {
    return { className: 'confirmed', label: 'confirmed' };
  }

  const displayMeta = getAppointmentDisplayMeta(appointment);
  const normalizedRescheduleStatus = String(rescheduleStatus || '')
    .trim()
    .toLowerCase()
    .replace(/[_\s-]+/g, ' ');
  const showRescheduleOnly =
    Boolean(normalizedRescheduleStatus) &&
    normalizedRescheduleStatus !== displayMeta.cssClass;

  if (showRescheduleOnly) {
    return {
      className: 'rescheduled',
      label: rescheduleStatus,
    };
  }

  return {
    className: displayMeta.cssClass,
    label: displayMeta.label,
  };
}
